/* eslint-disable
    eqeqeq,
*/
// TODO: This file was created by bulk-decaffeinate.
// Fix any style issues and re-enable lint.
/*
 * decaffeinate suggestions:
 * DS101: Remove unnecessary use of Array.from
 * DS102: Remove unnecessary code created because of implicit returns
 * DS207: Consider shorter variations of null checks
 * Full docs: https://github.com/decaffeinate/decaffeinate/blob/master/docs/suggestions.md
 */

import { isEmbeddedInAtlassian, isTouch } from '@trello/browser';
import { seesVersionedVariation } from '@trello/feature-flag-client';
// eslint-disable-next-line no-restricted-imports
import $ from '@trello/jquery';

// eslint-disable-next-line no-restricted-imports
import { Controller } from 'app/scripts/controller';
import { setTitleAndLocation } from 'app/scripts/controller/setTitleAndLocation';
import { getBoardUrl } from 'app/scripts/controller/urls';
import { Auth } from 'app/scripts/db/Auth';
import { Util } from 'app/scripts/lib/util';
import { templates } from 'app/scripts/views/internal/templates';
import { DragSort } from 'app/scripts/views/lib/DragSort';
import { BoardTemplate } from 'app/scripts/views/templates/BoardTemplate';
import { boardSidebarReadyState } from 'app/src/components/BoardDescriptionSpotlight/useIsBoardSidebarReady';
import { enableDragScroll } from 'app/src/enableDragScroll';
import { renderInviteeOrientation } from './renderInviteeOrientation';

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const _applySettings = function (this: any) {
  if (this.options.settings == null) {
    return;
  }

  const { menu, filter } = this.options.settings;

  switch (menu) {
    case 'closed':
      this.model.viewState.setShowSidebar(false);
      break;
    case 'filter':
    case 'activity':
      this.sidebarViewPromise.then(() => {
        this.setSidebarShow();
        return this.sidebarView.pushView(menu);
      });
      break;
    default:
  }

  if (filter) {
    return this.model.filter.fromQueryString(filter);
  }
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const renderOpen = function (this: any) {
  this.showSidebarOnOpen();

  const data = {};
  // @ts-expect-error TS(2339): Property 'url' does not exist on type '{}'.
  data.url = getBoardUrl(this.model);
  for (const preference of Array.from(
    this.model.prefNames.concat(this.model.myPrefNames),
  )) {
    // @ts-expect-error TS(7053): Element implicitly has an 'any' type because expre... Remove this comment to see the full error message
    data[`${preference}_${this.model.getPref(preference)}`] = true;
  }
  // @ts-expect-error TS(2339): Property 'canJoin' does not exist on type '{}'.
  data.canJoin = this.model.canJoin();
  // @ts-expect-error TS(2339): Property 'canInviteMembers' does not exist on type... Remove this comment to see the full error message
  data.canInviteMembers = this.model.canInviteMembers();
  // @ts-expect-error TS(2339): Property 'confirmed' does not exist on type '{}'.
  data.confirmed = Auth.me().get('confirmed');

  if (this.listRenderingMode === 'backbone') {
    this.listListView.$el.detach();
  }

  this.$el.html(
    templates.fillFromModel(BoardTemplate, this.model, {
      isCollapsedWorkspaceNav: !this.workspaceNavState.expanded,
      isBoardHeaderRewrite: seesVersionedVariation(
        'panorama.board-header-rewrite',
        'alpha',
      ),
    }),
  );

  this.renderBoardHeader();
  this.renderBoardWarnings();
  this.renderBoardBackground();

  // On Backbone renders, running showBoardDetailView mounts the correct view
  // (table, maps, powerups, etc) from the URL, otherwise it will disappear.
  // @ts-expect-error TS(2339): Property 'boardPageSettings' does not exist on typ... Remove this comment to see the full error message
  const args = { ...this.options, ...Controller.boardPageSettings };
  this.showBoardDetailView(args);

  // this prevents the sidebar from animating in when first rendering.
  if (this.model.viewState.get('showSidebar') && !isEmbeddedInAtlassian()) {
    this.$el.addClass('is-show-menu');
  }

  this.sidebarViewPromise.then(() => {
    this.appendSubview(this.sidebarView, $('.js-fill-board-menu', this.$el));
    return this.renderSidebarState();
  });

  this.renderLists();
  renderInviteeOrientation({
    $el: this.$el,
    el: this.el,
    idBoard: this.model.id,
  });

  // @ts-expect-error TS(2345): Argument of type '{ title: any; }' is not assignab... Remove this comment to see the full error message
  setTitleAndLocation({ title: data.name });

  this.defer(() => {
    enableDragScroll(this.el.querySelector('#board'), {
      fxIgnore(event) {
        // @ts-expect-error TS(2769): No overload matches this call.
        const boardEl = $(event.target).closest('#board');
        const isScrollbar = event.offsetY > boardEl.height() - 11;
        // @ts-expect-error TS(2769): No overload matches this call.
        const isList = $(event.target).closest('.js-list-content').length > 0;
        const isListComposer =
          // @ts-expect-error TS(2769): No overload matches this call.
          $(event.target).closest('.js-add-list').length > 0;
        return isScrollbar || isList || isListComposer;
      },
    });

    return DragSort.refreshListSortable();
  });
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const _shouldCloseBoardMenu = function (this: any) {
  // @ts-expect-error TS(2362): The left-hand side of an arithmetic operation must... Remove this comment to see the full error message
  const isNewBoard = new Date() - Util.idToDate(this.model.id) < 180000;

  // if a previous render of this board marked it as needing its menu closed,
  // keep it closed until the user opens it themselves
  return (
    this.shouldCloseBoardMenu ||
    // close the menu of the first board they ever load
    !Auth.me().isDismissed('close-menu-of-first-board') ||
    // close menu of first board ever created, which may not be the same as the
    // first board they ever load, because of invitations
    (isNewBoard && this.model.isFirstOwnedBoard())
  );
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const _isFirstBoardEverLoaded = function (this: any) {
  return (
    !Auth.me().isDismissed('close-menu-of-first-board') &&
    !this.model.isWelcomeBoard()
  );
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const _isGhostUsingInviteLink = function (this: any) {
  // @ts-expect-error TS(2554): Expected 2 arguments, but got 1.
  return Util.hasValidInviteTokenFor(this.model);
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const removeSidebarDisplayTypes = function (this: any) {
  this.$el.removeClass('sidebar-display-wide');
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const renderSidebarDisplayType = function (this: any) {
  const displayClass = this.model.viewState.getSidebarDisplayType();
  this.$el.addClass(displayClass);
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const showSidebarOnOpen = function (this: any) {
  // Orient visitors to public boards if About This Board is enabled
  const fromPrefOrNotLoggedIn =
    this.model.viewState.getShowSidebarFromPref() ||
    // @ts-expect-error TS(2345): Argument of type '"notLoggedIn"' is not assignable... Remove this comment to see the full error message
    Auth.me().get('notLoggedIn');
  const hasDesc = !!this.model.get('desc');
  const isMember = this.model.isMember(Auth.me());

  if (
    this.model.isPublic() &&
    !isMember &&
    hasDesc &&
    fromPrefOrNotLoggedIn &&
    !isTouch()
  ) {
    return this.model.viewState.set('showSidebar', true);
  } else if (this._shouldCloseBoardMenu() || isTouch()) {
    this.model.viewState.set('showSidebar', false);
    if (this._isFirstBoardEverLoaded() && !this._isGhostUsingInviteLink()) {
      this.shouldCloseBoardMenu = true;
      if (Auth.isLoggedIn()) {
        return Auth.me().dismiss('close-menu-of-first-board');
      }
    }
  } else {
    return this.model.viewState.setShowSidebarFromPref();
  }
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const renderSidebarState = function (this: any) {
  this.renderSidebarDisplayType();

  if (this.model.viewState.get('showSidebar') && !isEmbeddedInAtlassian()) {
    this.showSidebar();
  } else {
    this.hideSidebar();
  }
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const toggleSidebar = function (this: any) {
  return this.model.viewState.setShowSidebar(
    !this.model.viewState.get('showSidebar'),
  );
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const setSidebarShow = function (this: any) {
  this.model.viewState.setShowSidebar(true);
  this.shouldCloseboardMenu = false;
};

export const setSidebarTransitionState = () => {
  boardSidebarReadyState.setValue(false);
  $('.board-menu').one('transitionend webkitTransitionEnd', (e) => {
    boardSidebarReadyState.setValue(true);
  });
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const showSidebar = function (this: any) {
  setSidebarTransitionState();
  this.renderSidebarDisplayType();
  // this hides team onboarding tooltip that shows after you dismiss
  // the popover, which we should just close when the sidebar opens
  this.unmountTeamOnboardingPupTooltip();

  // Hacky... the entire transition will be hidden if
  // there isn't a slight delay between unhiding and
  // enabling the transition class.
  clearTimeout(this._sidebarHideTimeout);
  $('.js-fill-board-menu', this.$el).removeClass('hide');
  this.defer(() => {
    return this.$el.addClass('is-show-menu');
  });

  this.sidebarViewPromise.then(() => {
    return this.sidebarView.sendDrawerScreenEvent(
      this.sidebarView.topSidebarViewName(),
      'showSidebar',
    );
  });
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any
export const hideSidebar = function (this: any) {
  boardSidebarReadyState.setValue(false);
  this.$el.removeClass('is-show-menu');
  clearTimeout(this._sidebarHideTimeout);
  // Even though the is-show-menu class moves the menu out of view, we want
  // to also *actually* hide it, so the browser doesn't does something weird
  // when the user does something like Ctrl+F for text that appears in the
  // sidebar.
  //
  // We're delaying the hide because we're giving the CSS transition time to
  // complete.  We could try to trigger off of the transitionEnd event but
  // that can be problematic (if another transition starts before the first
  // one finishes or doesn't happen at all because there isn't actually a
  // change in the property being transitioned)
  //
  // The timeout value we're using here isn't meant to match the length of the
  // transition, but hopefully it's longer than whatever the transition is,
  // but not so short that someone could reasonably hide the menu and then
  // Ctrl+F for something that was on it
  this._sidebarHideTimeout = this.setTimeout(() => {
    $('.js-fill-board-menu', this.$el).addClass('hide');
    boardSidebarReadyState.setValue(true);
  }, 250);
};
